import { useState, useCallback } from 'react';
import { finBillDataApi } from '../../../services/finBillDataApi';

export function useFinBillDataNavigation(onNavigate: (id: number) => Promise<unknown>) {
  const [allIds, setAllIds] = useState<number[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of bill IDs */
  const loadList = useCallback(async (): Promise<number[]> => {
    const res = await finBillDataApi.list(1, 10000);
    const ids = (res.data || []).map(r => r.bill_mid).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
